// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"styles_buttonWrapper__YKpI6","voidButton":"styles_voidButton__lJiXC","disabledSection":"styles_disabledSection__Ia68E"};